var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIonic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8FF6",
    d: "M12 6.529a5.475 5.475 0 0 0-5.471 5.47 5.475 5.475 0 0 0 5.47 5.47 5.475 5.475 0 0 0 5.47-5.47A5.479 5.479 0 0 0 12 6.529z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.85,
    cy: 4.522,
    r: 2.494,
    fill: "#4E8FF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E8FF6",
    d: "M12 24c6.619 0 12-5.381 12-12 0-1.73-.361-3.403-1.078-4.973l-.001-.001-.103-.23-.169.188c-.408.464-.928.82-1.505 1.036l-.159.061.066.155a9.586 9.586 0 0 1 .75 3.749v.01c0 5.405-4.397 9.806-9.806 9.806s-9.802-4.397-9.802-9.802 4.402-9.806 9.806-9.806c1.467 0 2.883.319 4.2.947l.155.075.066-.155c.254-.582.63-1.07 1.099-1.447l.007-.006.197-.159-.225-.117A11.745 11.745 0 0 0 12.028 0H12C5.381 0 0 5.381 0 12s5.381 12 12 12z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonic);
export default __webpack_public_path__ + "static/media/ionic.e5a641e24acb7f99e9c4ff996d5265d6.svg";
export { ForwardRef as ReactComponent };